export default __webpack_public_path__ + "static/media/1.692b460f.jpg";